import { useEffect } from "react";

// Central SEO helper — sets title / meta description / canonical / Open Graph
// and optional JSON-LD for the current page. SPA-safe (updates on route change).
function setMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!content) { if (el) el.remove(); return; }
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function Seo({ title, description, image, path, jsonLd }) {
    useEffect(() => {
        const url = `${window.location.origin}${path || window.location.pathname}`;
        if (title) document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("property", "og:type", "website");
        setMeta("property", "og:site_name", "ITZKATU");
        setMeta("property", "og:image", image || "");
        setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);
        let script = document.getElementById("seo-jsonld");
        if (jsonLd) {
            if (!script) {
                script = document.createElement("script");
                script.type = "application/ld+json";
                script.id = "seo-jsonld";
                document.head.appendChild(script);
            }
            script.textContent = JSON.stringify(jsonLd);
        } else if (script) {
            script.remove();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, description, image, path, JSON.stringify(jsonLd || null)]);
    return null;
}
